export type OwnershipState = "OWNED" | "LOCKED";

export function isEffectivelyOwned(
	itemSlug: string,
	warbondSlug: string,
	ownedItems: Set<string>,
	excludedItems: Set<string>,
	ownedWarbonds: Set<string>,
): boolean {
	if (ownedItems.has(itemSlug)) {
		return true;
	}
	if (ownedWarbonds.has(warbondSlug) && !excludedItems.has(itemSlug)) {
		return true;
	}
	return false;
}

export function resolveOwnership(
	itemSlug: string,
	warbondSlug: string,
	ownedItems: Set<string>,
	excludedItems: Set<string>,
	ownedWarbonds: Set<string>,
): OwnershipState {
	return isEffectivelyOwned(
		itemSlug,
		warbondSlug,
		ownedItems,
		excludedItems,
		ownedWarbonds,
	)
		? "OWNED"
		: "LOCKED";
}
